import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";
import { NV_PATHS } from "./nv-paths";

// Figma "Footer (ver.5 · 스테이징 기준)" (546:4379), 1440 x 258: staging site footer — PwC logo + tagline,
// 법률 links (개인정보 처리방침 · 이용약관), divider, copyright. The product column of the staging footer is not used.
const LEGAL_LINKS = [
  { label: "개인정보 처리방침", to: NV_PATHS.privacy },
  { label: "이용약관", to: NV_PATHS.terms },
];

export interface NvFooterProps {
  className?: string;
}

function NvFooter({ className }: NvFooterProps) {
  return (
    <footer className={cn("w-full border-t border-nv-border bg-nv-bg-page", className)}>
      <div className="flex flex-col gap-8 px-10 pb-8 pt-12">
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-4">
            <img src="/images/logos/logo-pwc-footer.svg" alt="PwC" width={74} height={36} className="h-9 w-[74px]" />
            <p className="whitespace-pre-line text-[14px] leading-[21px] text-nv-text-secondary">
              {"Empowering businesses with AI intelligence\nfor a smarter future."}
            </p>
          </div>

          <nav aria-label="법률" className="flex flex-col gap-[10px]">
            <span className="text-[13px] font-bold leading-5 text-nv-text-primary">법률</span>
            {LEGAL_LINKS.map((link) => (
              <Link key={link.label} to={link.to} className="text-[13px] leading-5 text-nv-text-secondary hover:text-nv-text-primary">
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div aria-hidden className="h-px w-full bg-nv-divider" />
        <p className="text-[12px] leading-[18px] text-nv-text-secondary">© 2026 AI Agent Navigator. All rights reserved.</p>
      </div>
    </footer>
  );
}

export { NvFooter };
